import React from 'react';
import { connect } from 'react-redux';
import CreateChannelModal from './CreateChannelModal';
import DeleteDoubleCheckModal from './DeleteDoubleCheckModal';
import RepExplainerModal from './RepExplainerModal';
import ChangeChannelModal from './ChangeChannelModal';
import RestoreChannelModal from './RestoreChannelModal';
import ReportUserModal from './ReportUserModal';
import BanUserModal from './BanUserModal';
import CloseComposerConfirmationModal from './CloseComposerConfirmationModal';
import CreatePostModal from './CreatePostModal';
import EditCommentModal from './EditCommentModal';
import CreateEventModal from './CreateEventModal';
import EditEventModal from './EditEventModal';
import ReportModal from './ReportModal';
import JoinGroupModal from './JoinGroupModal';
import ImageModal from './ImageModal';
import VideoPlaybackModal from './VideoPlaybackModal';
import JoinGroupReminderModal from './JoinGroupReminderModal';

const MODAL_COMPONENTS = {
  CREATE_CHANNEL_MODAL: CreateChannelModal,
  DELETE_DOUBLE_CHECK_MODAL: DeleteDoubleCheckModal,
  REP_EXPLAINER_MODAL: RepExplainerModal,
  CHANGE_CHANNEL: ChangeChannelModal,
  RESTORE_CHANNEL_MODAL: RestoreChannelModal,
  REPORT_USER_MODAL: ReportUserModal,
  BAN_USER_MODAL: BanUserModal,
  CLOSE_COMPOSER_CONFIRMATION_MODAL: CloseComposerConfirmationModal,
  CREATE_POST_MODAL: CreatePostModal,
  EDIT_COMMENT_MODAL: EditCommentModal,
  CREATE_EVENT_MODAL: CreateEventModal,
  EDIT_EVENT_MODAL: EditEventModal,
  REPORT_MODAL: ReportModal,
  JOIN_GROUP_MODAL: JoinGroupModal,
  IMAGE_MODAL: ImageModal,
  VIDEO_PLAYBACK_MODAL: VideoPlaybackModal,
  JOIN_GROUP_REMINDER_MODAL: JoinGroupReminderModal,
};

/*
  Takes a modalType and modalProps to dynamically return the
  modal component we imported above
*/
const modalRoot = ({ modalType, modalProps }) => {
  if (!modalType) {
    return null;
  }

  const SpecificModal = MODAL_COMPONENTS[modalType];
  return <SpecificModal {...modalProps} />;
};

const mapStateToProps = state => ({
  modalProps: state.modals.modalProps,
  modalType: state.modals.modalType,
});

// $FlowIssue
export default connect(mapStateToProps)(modalRoot);
